import type { Template } from "@/types";

export const LA_06_H2_V4: Template[] = [
    {
        id: "la-06-h2v4-01",
        name: "LA 01 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 65, y: 53, width: 256, height: 427, rotation: 0, imageRotation: 0 },
            { id: "2", x: 329, y: 53, width: 282, height: 209, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 271, width: 282, height: 209, rotation: 0, imageRotation: 0 },
            { id: "4", x: 790, y: 53, width: 294, height: 427, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1092, y: 53, width: 150, height: 210, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1092, y: 271, width: 150, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-02",
        name: "LA 02 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 174, y: 35, width: 329, height: 461, rotation: 0, imageRotation: 0 },
            { id: "2", x: 788, y: 35, width: 334, height: 227, rotation: 0, imageRotation: 0 },
            { id: "3", x: 788, y: 270, width: 334, height: 227, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1130, y: 35, width: 117, height: 149, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1130, y: 192, width: 117, height: 148, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1130, y: 348, width: 117, height: 148, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-03",
        name: "LA 03 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 175, y: 53, width: 325, height: 208, rotation: 0, imageRotation: 0 },
            { id: "2", x: 175, y: 269, width: 325, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 859, y: 53, width: 151, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 859, y: 269, width: 151, height: 208, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 53, width: 151, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 269, width: 151, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-04",
        name: "LA 04 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 120, y: 50, width: 140, height: 212, rotation: 0, imageRotation: 0 },
            { id: "2", x: 268, y: 50, width: 288, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 120, y: 270, width: 140, height: 211, rotation: 0, imageRotation: 0 },
            { id: "4", x: 268, y: 270, width: 140, height: 211, rotation: 0, imageRotation: 0 },
            { id: "5", x: 416, y: 270, width: 140, height: 211, rotation: 0, imageRotation: 0 },
            { id: "6", x: 767, y: 91, width: 494, height: 349, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-05",
        name: "LA 05 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 118, y: 49, width: 440, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 118, y: 333, width: 105, height: 149, rotation: 0, imageRotation: 0 },
            { id: "3", x: 230, y: 333, width: 105, height: 149, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 333, width: 105, height: 149, rotation: 0, imageRotation: 0 },
            { id: "5", x: 454, y: 333, width: 104, height: 149, rotation: 0, imageRotation: 0 },
            { id: "6", x: 767, y: 91, width: 494, height: 349, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-06",
        name: "LA 06 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 65, y: 73, width: 477, height: 386, rotation: 0, imageRotation: 0 },
            { id: "2", x: 550, y: 73, width: 124, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 550, y: 270, width: 124, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 682, y: 73, width: 124, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 682, y: 270, width: 124, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 814, y: 73, width: 474, height: 386, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-07",
        name: "LA 07 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 64, y: 73, width: 124, height: 189, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 270, width: 124, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 196, y: 73, width: 477, height: 386, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 73, width: 125, height: 189, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 270, width: 125, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 814, y: 73, width: 474, height: 386, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-08",
        name: "LA 08 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 65, y: 73, width: 124, height: 189, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 270, width: 124, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 197, y: 73, width: 124, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 197, y: 270, width: 124, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 329, y: 73, width: 477, height: 386, rotation: 0, imageRotation: 0 },
            { id: "6", x: 814, y: 73, width: 474, height: 386, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-09",
        name: "LA 09 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 52, width: 527, height: 429, rotation: 0, imageRotation: 0 },
            { id: "2", x: 535, y: 52, width: 138, height: 210, rotation: 0, imageRotation: 0 },
            { id: "3", x: 535, y: 271, width: 138, height: 210, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 52, width: 526, height: 429, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1215, y: 52, width: 137, height: 210, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1215, y: 271, width: 137, height: 210, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-10",
        name: "LA 10 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 73, width: 551, height: 388, rotation: 0, imageRotation: 0 },
            { id: "2", x: 559, y: 73, width: 114, height: 190, rotation: 0, imageRotation: 0 },
            { id: "3", x: 559, y: 271, width: 114, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 73, width: 113, height: 190, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 271, width: 113, height: 189, rotation: 0, imageRotation: 0 },
            { id: "6", x: 802, y: 73, width: 550, height: 388, rotation: 0, imageRotation: 0 }
        ],
    }
];